import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { TableColumnsFilter } from 'common/ColumnsFilter/ColumnsFilter';
import { FilterButton } from 'common/FilterButton/FilterButton';
import type { Room } from 'services/api';
import type { Key } from 'react';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';
import styles from './Controls.module.scss';

interface RoomsTableControlsProps {
  createRoom: () => void;
  columns: AppTableColumn<Room>[];
  visibleKeys: Key[];
  setVisibleKeys: (activeKeys: Key[]) => void;
  filterCount?: number;
  showSider: () => void;
}

export const RoomsTableControls = ({
  columns,
  setVisibleKeys,
  showSider,
  filterCount,
  createRoom,
  visibleKeys,
}: RoomsTableControlsProps) => {
  return (
    <AppFlex direction="row" justifyContent="flex-end" className={styles.controls}>
      <AppButton onClick={createRoom}>Создать</AppButton>
      <FilterButton count={filterCount} click={showSider} />
      <TableColumnsFilter
        visibleKeys={visibleKeys}
        columns={columns}
        setVisibleKeys={setVisibleKeys}
      />
    </AppFlex>
  );
};
